import { render, staticRenderFns } from "./EditCPBroker.vue?vue&type=template&id=0462e95c&"
import script from "./EditCPBroker.vue?vue&type=script&lang=js&"
export * from "./EditCPBroker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports